// extracted by mini-css-extract-plugin
export default {"grid":"Table_grid__uV5y9","table":"Table_table__d8z2Y","alwaysStripy":"Table_alwaysStripy__vDr7s"};